"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavMenu = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_router_dom_1 = require("react-router-dom");
var StyleComponents_1 = require("./base/StyleComponents");
var fa_1 = require("react-icons/fa");
var NavMenu = function () {
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var toggle = function () {
        setIsOpen(!isOpen);
    };
    return (
    /* <header style={{ position: 'absolute', zIndex: 2, width: '100%' }}>*/
    React.createElement("header", { style: {} },
        React.createElement(reactstrap_1.Navbar, { style: {
                backgroundColor: isOpen ? StyleComponents_1.greenColor : 'rgba(8, 86, 16, 0.5)',
                zIndex: 9999,
                letterSpacing: '.15em',
                fontSize: 15,
                fontWeight: 700
            }, container: "md", expand: "lg", 
            //fixed="top"
            dark: true },
            React.createElement(reactstrap_1.NavbarBrand, { tag: react_router_dom_1.Link, to: "/" },
                React.createElement("img", { style: { height: 50 }, src: 'image/logo_pelne2.png' })),
            React.createElement(reactstrap_1.NavbarToggler, { onClick: toggle }),
            React.createElement(reactstrap_1.Collapse, { isOpen: isOpen, navbar: true },
                React.createElement(reactstrap_1.Nav, { className: "me-auto", navbar: true },
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/" }, "STRONA G\u0141\u00D3WNA")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/wina" }, "WINA")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/spacer" }, "WIRTUALNY SPACER")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/galeria" }, "GALERIA")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/kontakt" }, "KONTAKT")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { href: "http://sklep.winnicaswidnicka.eu" }, "SKLEP")),
                    React.createElement(reactstrap_1.NavItem, { style: { display: 'flex' } },
                        React.createElement(reactstrap_1.NavLink, { href: "https://www.facebook.com/WinnicaSwidnicka/" },
                            React.createElement(fa_1.FaFacebookSquare, null)),
                        React.createElement(reactstrap_1.NavLink, { href: "https://www.instagram.com/winnica.swidnicka/" },
                            React.createElement(fa_1.FaInstagramSquare, null))))))));
};
exports.NavMenu = NavMenu;
//# sourceMappingURL=NavMenu.js.map